import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Portfolio',
    href: '#portfolio'
  }, {
    name: 'Process',
    href: '#process'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Contact Us',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/90 backdrop-blur-md py-4 shadow-lg shadow-blue-900/10 border-b border-white/5' : 'bg-transparent py-6'}`} data-id="element-223" data-mp="1px9ma8h1l8cj">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-224" data-mp="9o7unzf5bemc">
        <a href="#" className="flex items-center gap-2 group" data-id="element-225" data-mp="elzkmnw8cqnw">
          <span className="font-heading font-bold text-xl tracking-tight text-white" data-id="element-226" data-mp="jmdtg85no4mz">
            Mike's <span className="text-blue-500" data-id="element-227" data-mp="om9xu8i9ly32">Pro</span> Web Design
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-228" data-mp="3n4fbfa4u6vqv">
          {navLinks.map(link => <a key={link.name} href={link.href} className="font-medium hover:text-white transition-colors relative group text-[#FFFFFF] text-[16px]" data-id="element-229" data-mp="3s1nt79m2oxrl">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-500 transition-all group-hover:w-full" data-id="element-230" data-mp="5mm97pojps0j"></span>
            </a>)}
          <a href="#contact" className="px-5 py-2.5 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-white text-sm font-medium transition-all hover:border-blue-500/50" data-id="element-231" data-mp="34btd8j6git34">
            Get a Quote
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-slate-300 hover:text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-232" data-mp="2wcq7cdrvrk8k">
          {isMobileMenuOpen ? <X size={28} data-id="element-233" data-mp="3b0b6xxpjr1bq" /> : <Menu size={28} data-id="element-234" data-mp="3b2xg21s35ow2" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-235" data-mp="362rth00oasku">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-black border-b border-white/10 overflow-hidden" data-id="element-236" data-mp="2ibvunixsux43">
            <div className="px-6 py-4 flex flex-col gap-4" data-id="element-237" data-mp="2s88pik52zh0f">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-slate-300 hover:text-white py-2" data-id="element-238" data-mp="2na7803nazpr2">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="mt-2 w-full py-3 rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 text-white text-center font-medium" data-id="element-239" data-mp="2nm1n073lluu">
                Get a Quote
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}